import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import { WrapContent } from 'app/components/WrapContent';
import useAxios from 'axios-hooks';
import useDictionary from 'hooks/useDictionary';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { notification } from 'utils/notification';
import { ACTIVE_TF, USER_TP } from 'constant';

const List = React.lazy(() => import('./List'));
const CreateEditView = React.lazy(() => import('./CreateEditView'));
const UserService = React.lazy(() => import('./UserService'));
const ViewCompany = React.lazy(() => import('./ViewCompany'));
const ViewUser = React.lazy(() => import('./ViewUser'));

/**
 * create context
 */
const ModuleContext = createContext({});
ModuleContext.displayName = 'UserManager_Context';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};

const UserManager = () => {
  const { t }: any = useDictionary({ programId: 'user-manager' });
  const [data, setData] = useState([]);
  const [modeView, setModeView] = useState({
    type: 'list',
    data: null,
  });

  const [{ loading }, refetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  useEffect(() => {
    onSubmit();
  }, []);

  /**
   * on submit
   *
   */
  const onSubmit = async () => {
    const res = await refetchData({
      url: '/user-manager',
      method: 'GET',
    });
    if (res?.data?.status === '200') {
      const resMapping = (res?.data?.data || []).map(o => ({
        ...o,
        userTpNm: USER_TP?.[o.userTp],
        status: o.activeTf ? ACTIVE_TF.true : ACTIVE_TF.false,
      }));
      setData(resMapping);
    } else {
      notification({ res });
    }
  };

  const value: any = {
    t,
    data,
    setData,
    modeView,
    setModeView,
    onSubmit,
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      case 'create':
      case 'edit':
        return <CreateEditView />;
      case 'service':
        return <UserService />;
      case 'company':
        return <ViewCompany />;
      case 'user':
        return <ViewUser />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <WrapContent>
      <ModuleContext.Provider value={value}>
        <React.Suspense fallback={<LoadPanel visible={true} />}>
          <LoadPanel visible={loading} />
          {renderContent()}
        </React.Suspense>
      </ModuleContext.Provider>
    </WrapContent>
  );
};

export default UserManager;
